import { render, staticRenderFns } from "./sidebar_weight.vue?vue&type=template&id=31245cdc&"
import script from "./sidebar_weight.vue?vue&type=script&lang=js&"
export * from "./sidebar_weight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "sidebar_weight.vue"
export default component.exports